var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBoldCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4zm0 3.097c7.131 0 12.903 5.77 12.903 12.903 0 7.131-5.77 12.903-12.903 12.903-7.131 0-12.903-5.77-12.903-12.903 0-7.131 5.77-12.903 12.903-12.903zm9.045 8.404l-1.454-1.466a.774.774 0 00-1.094-.004l-9.12 9.046-3.857-3.889a.774.774 0 00-1.095-.004l-1.466 1.454a.774.774 0 00-.004 1.095l5.856 5.904a.774.774 0 001.095.004l11.135-11.045a.774.774 0 00.004-1.095z"
  })));
}
export default SvgCheckmarkBoldCircle;